import axios from '../helpers/axios'
import qs from 'querystring';
import { logError } from '../services';
import {
  IResponse, IProjectManagerUpdate,
  IProjectManagerActiveNeighborhood,
  IDropdownResponse
} from '../models';
import { IForemanUser, IForemanUserCreate, IForemanUserDetail } from "../models/foremen";

const baseUrl = "/api/foreman-users";
export const getForemanUsers = async (filters?: {
  neighborhoodId: string | number;
  sortDirection: string;
  searchTerm: string;
  perPage: number;
  territoryId: string | number;
  sortBy: string;
  page: number
}): Promise<IResponse<IForemanUser[]>> => {
  try {
    const { data } = await axios.get(baseUrl,{
      params: filters,
      paramsSerializer: params => qs.stringify(params)
    });
    return data;
  } catch (error: any) {
    logError(error, 'getForemanUsers failed');
    return Promise.reject(error.response.data);
  }
};

export const createForemanUser = async (payload: IForemanUserCreate): Promise<number> => {
  try {
    const { data } = await axios.post(baseUrl, payload);
    return data;
  } catch (error: any) {
    logError(error, 'createForemanUser failed');
    return Promise.reject(error.response.data);
  }
};

export const getForemanUserDetail = async (
  foremanUserId: string | number
): Promise<IForemanUserDetail> => {
  try {
    const { data } = await axios.get(`${baseUrl}/${foremanUserId}`);
    return data;
  } catch (error: any) {
    logError(error, 'getForemanUserDetail failed');
    return Promise.reject(error.response.data);
  }
};

export const updateForemanUser = async (
  foremanUserId: string | number,
  payload: IProjectManagerUpdate
): Promise<any> => {
  try {
    const { data } = await axios.put(`${baseUrl}/${foremanUserId}`, payload);
    return data;
  } catch (error: any) {
    logError(error, 'updateForemanUser failed');
    return Promise.reject(error.response.data);
  }
};

export const deleteForemanUser = async (foremanUserId: string | number) => {
  try {
    const { data } = await axios.delete(`${baseUrl}/${foremanUserId}`);
    return data;
  } catch (error: any) {
    logError(error, 'deleteForemanUser failed');
    return Promise.reject(error.response.data);
  }
};

export const getForemanUsersLookup = async (): Promise<IDropdownResponse[]> => {
  try {
    const { data } = await axios.get(`${baseUrl}/lookup`);

    return data;
  } catch (error: any) {
    logError(error, 'getForemanUsersLookup failed');
    return Promise.reject(error?.response?.data);
  }
};

export const getForemanUserNeighborhoodNames = async (
  foremanUserId: string | number
): Promise<any[]> => {
  try {
    const { data } = await axios.get(
      `${baseUrl}/${foremanUserId}/neighborhood-names`
    );
    return data;
  } catch (error: any) {
    logError(error, 'getForemanUserNeighborhoodNames failed');
    return Promise.reject(error.response.data);
  }
};

export const getForemanUserAvailableNeighborhoods = async (
  foremanUserId: string | number
): Promise<IProjectManagerActiveNeighborhood[]> => {
  try {
    const { data } = await axios.get(
      `${baseUrl}/${foremanUserId}/available-neighborhoods`
    );
    return data;
  } catch (error: any) {
    logError(error, 'getForemanUserAvailableNeighborhoods failed');
    return Promise.reject(error.response.data);
  }
};

export const createForemanUserNeighborhood = async (
  foremanUserId: string | number,
  neighborhoodId: string | number
): Promise<any> => {
  try {
    const { data } = await axios.post(
      `${baseUrl}/${foremanUserId}/neighborhoods/${neighborhoodId}`
    );
    return data;
  } catch (error: any) {
    logError(error, 'createForemanUserNeighborhood failed');
    return Promise.reject(error.response.data);
  }
};

export const deleteForemanUserNeighborhood = async (
  foremanUserId: string | number,
  neighborhoodId: string | number
): Promise<any> => {
  try {
    const { data } = await axios.delete(
      `${baseUrl}/${foremanUserId}/neighborhoods/${neighborhoodId}`
    );
    return data;
  } catch (error: any) {
    logError(error, 'deleteForemanUserNeighborhood failed');
    return Promise.reject(error.response.data);
  }
};
